import COUNTIES from './counties.json';
export const US_COUNTIES = COUNTIES;
